<template>
    <div class="ChurchList">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h2><font-awesome-icon :icon="['fa', 'church']" /> Churches <span v-b-tooltip.hover title="Add Church" style="float:right;"><font-awesome-icon v-if="Filters[0].Value == 'Suspect/Prospect/Informed'" :icon="['fa', 'plus']" v-on:click="ShowAddChurch()" class="olive-green-text pointer" /></span></h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <GenericDataTable ref="datatable"
                                  @recordclicked="OnRecordClicked"
                                  :table-fields="Fields"
                                  :data-filters="Filters"
                                  :table-slots="Slots"
                                  data-endpoint="StrongFamilies/Churches"
                                  data-method="GET"
                                  :load-indicator="true"
                                  data-commit-name="Churches.ChurchEnrollmentsList.Replace" 
                                  :load-data-on-mounted="false"/>
                </div>
            </div>
        </div>
        <NewChurch ref="component-add-church" @updatetable="OnUpdateTable" />
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    import GenericDataTable from '../../../Core/UI/GenericDataTable.vue';
    import NewChurch from './NewChurch.vue';

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        created() {
            //this.$store.commit("Clients.ClientProfiles.Clear");
            //this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            EventBus.$on('global-update-initiated', this.OnUpdateTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        props: [],
        data: function () {
            return {
                //DATA TABLE CONFIGURATION
                Fields: [
                    {
                        name: '__slot:OpenProfile',
                        title: 'Name',
                        sortField: 'Name',
                    },
                    {
                        name: 'Name',
                        title: 'Name',
                        visible: false
                    },
                    {
                        name: 'SubProgramTerritory.Name',
                        title: 'Territory',
                        sortField: 'SubProgramTerritory.Name'
                    },
                    {
                        name: 'PhysicalAddress.CityState',
                        title: 'Location',
                        sortField: 'PhysicalAddress.CityState'
                    },
                    {
                        name: 'Status',
                        title: "Status",
                        sortField: 'Status'
                    }
                ],
                Filters: [
                    {
                        Name: "Status",
                        Label: "Status",
                        Options: [
                            {
                                text: "All",
                                value: "All"
                            },
                            {
                                text: "Active/Engaged/Equipped",
                                value: "Active/Engaged/Equipped"
                            },
                            {
                                text: "Suspect/Prospect/Informed",
                                value: "Suspect/Prospect/Informed"
                            },
                            {
                                text: "Inactive",
                                value: "Inactive"
                            }
                        ],
                        Value: "Active/Engaged/Equipped"
                    },
                    {
                        Name: "SubProgramID",
                        Label: "Program",
                        Options: [

                        ],
                        Value: ""
                    },
                    {
                        Name: "SubProgramTerritoryID",
                        Label: "Territory",
                        Options: [

                        ],
                        Value: null
                    },
                ],
                Slots: [
                    {
                        Name: "OpenProfile",
                        DisplayProperty: "Name",
                        EventName: "recordclicked"
                    }
                ]
            };
        },
        methods: {
            //UI
            ShowAddChurch() {
                this.$refs["component-add-church"].ShowModal();
            },
            OnUpdateTable() {
                this.$refs["datatable"].GetData();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnRecordClicked(rowData) {
                this.$store.commit("Churches.Profiles.Append", rowData);
                this.$parent.ChangePaneShown(rowData.Id);
            }
        },
        components: {
            GenericDataTable,
            NewChurch
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            //Seed Sub Program Options
            if (this.SubProgramOptions.length > 0) {
                this.Filters[1].Value = this.SubProgramOptions[0].value;
            }
            this.Filters[1].Options = this.SubProgramOptions;

            //Seed SubProgram Territory Options
            this.Filters[2].Options = this.SubProgramTerritoryOptions;
            this.Filters[2].Options.push({ text: "All", value: null })

            this.OnUpdateTable();
        }
    }
</script>

<style scoped>
</style>